import { render } from "./RuiEdit.vue?vue&type=template&id=3d0b9a6e"
const script = {}
script.render = render

export default script